<template>
  <div v-if="isVisible">
    <center>
      <div class="sk-mb-80 sk-w-100">
        <div class="sk-circle">
          <PuSkeleton class="sk-h-100 " />
        </div>
      </div>
    </center>
    <div class="col-lg-6 mb-5 sk-w-200">
      <div>
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-lg-12 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-50" />
      </div>
    </div>
    <div class="col-md-6 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-md-6 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-md-6 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-md-6 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-lg-12 sk-mb-30">
      <div>
        <PuSkeleton class="sk-h-200" />
      </div>
    </div>
    <div class="col-lg-12 sk-mb-30">
      <div class="float-right sk-w-100">
        <PuSkeleton class="sk-h-30" />
      </div>
    </div>
    <div class="col-lg-12 sk-mb-30">
      <div></div>
    </div>
  </div>
</template>

<script>
import Skeleton from "vue-loading-skeleton";

export default {
  name: "CustomSkeleton",
  components: {
    Skeleton
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style>
/*css for skeleton*/
.pu-skeleton {
  line-height: unset !important;
}
.sk-mb-30 {
  margin-bottom: 30px;
}
.sk-circle {
  border-radius: 50%;
  overflow: hidden;
}
.sk-h-30 {
  height: 30px;
}
.sk-h-50 {
  height: 50px;
}
.sk-h-100 {
  height: 100px;
}
.sk-h-200 {
  height: 200px;
}
.sk-w-100 {
  width: 100px;
}
.sk-w-200 {
  width: 200px;
}
.sk-mb-80 {
  margin-bottom: 80px;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomSkeleton.vue